import { DateTime } from 'luxon';

export const kebabToCamelCase = (str: string): string =>
  str
    .split(/[-_]/)
    .reduce(
      (acc, substr, idx) =>
        acc +
        (idx > 0
          ? `${substr.charAt(0).toUpperCase()}${substr.slice(1)}`
          : substr),
      ''
    );

export const getMonthFromDate = (date: string): number =>
  DateTime.fromISO(date).toObject().month;

export const checkIfPaymentDateIsSameOrAfterPostaheadStart = (
  postaheadStart: string,
  paymentDate: string
): boolean => {
  const datePayment = DateTime.fromISO(paymentDate);
  let datePostAhead;

  if (DateTime.fromFormat(postaheadStart, 'yyyy-MM-dd HH:mm:ss').isValid) {
    datePostAhead = DateTime.fromFormat(postaheadStart, 'yyyy-MM-dd HH:mm:ss');
  } else if (DateTime.fromISO(postaheadStart).isValid) {
    datePostAhead = DateTime.fromISO(postaheadStart);
  }

  if (!datePostAhead) {
    return false;
  }

  return datePayment >= datePostAhead;
};
